module.exports = __webpack_public_path__ + "img/11_002.70e39dd4.webp";